module.exports = __webpack_public_path__ + "img/bg_BK.d2295944.png";